import { render, staticRenderFns } from "./AddFundsToReserve.vue?vue&type=template&id=b7c8e420&scoped=true&"
import script from "./AddFundsToReserve.vue?vue&type=script&lang=js&"
export * from "./AddFundsToReserve.vue?vue&type=script&lang=js&"
import style0 from "./AddFundsToReserve.vue?vue&type=style&index=0&id=b7c8e420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c8e420",
  null
  
)

export default component.exports